import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, CacheKeyEnum, ConfirmationComponent, Pager, Tag, TagService } from 'lib-trend-core';
import { Observable, Subject, debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs';
import { TagEditComponent } from './tag-edit/tag-edit.component';

@Component({
    selector: 'tag-component',
    // templateUrl: 'tag.component.html'
    templateUrl: 'tag.v2.component.html',
    styleUrl: 'tag.v2.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagComponent extends AbstractComponent implements OnInit {

  pager: Pager<Tag> = new Pager<Tag>({ perPage: 10 });

  listObservable: Observable<Pager<Tag>>;
  private termoDaBusca: Subject<string> = new Subject<string>();

  labelFilter: string = 'Categorias';
  defaultValue: string = '';

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    public tagService: TagService,
  ) {
    super(injector);
    this.setupForm();
    this.loadingContent = true;
    this.cacheKey = CacheKeyEnum.TAGS_LIST;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const cached = this.restoreState<Tag>();
    if (!cached) {
      this.getList();
      return;
    }
    this.pager = cached.pager;
    this.searchString = cached.search ?? '';
    this.loadingContent = false;

    if (this.searchString) {
      this.formGroup.get('search').setValue(this.searchString);
    }

    this.setupObservableSearch();
  }

  private setupForm(): void {
    this.formGroup = this.formBuilder.group({
      search: [''],
    });
  }

  private setupObservableSearch(): void {
    this.listObservable = this.termoDaBusca.pipe(
      takeUntil(this.destroy$),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(term => {
        this.searchString = term;
        return this.tagService.getAll(this.pager.page, this.pager.perPage, term, this.searchParams);
      })
    );
    this.listObservable.subscribe((pager: Pager<Tag>) => {
      this.pager = pager;
      this.persistListState(this.pager, this.searchString, this.searchParams);
    });
  }

  setValueSearch(term: string, label: string = 'Categorias'): void {
    this.defaultValue = term;
    this.formGroup.get('category')?.setValue(term);
    this.labelFilter = label;
  }

  search(termo: string) {
    this.pager.page = 1;
    this.termoDaBusca.next(termo);
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList();
  }

  getList() {
    this.loadingContent = true;
    this.searchParams = {
      company: this.getIDCurrentCompany(),
    };

    this.tagService.getAll(this.pager.page, this.pager.perPage, this.searchString, this.searchParams).subscribe({
      next: (value) => {
        this.pager = value;
        this.setupObservableSearch();
        this.persistListState(this.pager, this.searchString, this.searchParams);
      },
      complete: () => this.loadingContent = false,
      error: (err) => {
        this.alertService.error(err.error.message);
        this.loadingContent = false;
      },
    });
  }

  add(): void {
    const dialogRef = this.dialog.open(TagEditComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) this.getList();
    });
  }

  edit(item: Tag): void {
    const dialogRef = this.dialog.open(TagEditComponent, {
      width: '600px',
      data: item
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) this.getList();
    });
  }

  delete(item: Tag): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '600px'
    })
    dialogRef.afterClosed().subscribe(result => {
      if (Boolean(result) === true) {
        this.tagService.delete(item._id).subscribe({
          next: (value) => {
            this.alertService.success(this.t('tag.list.tagDeletedSuccess'));
            this.getList();
          },
          error: (err) => this.alertService.error(err.error.message)
        });
      }
    })
  }


}
